<script lang="ts" setup>
import { computed } from 'vue';

import type { AutoCompleteSuggestion } from '@libs/trip-planner-interfaces';
import { exhaustiveGuard } from '@libs/utils';

import { DestinationSelector } from '../../destinationSelector';
import { AutoCompleteType } from '../../autoComplete';
import type { SelectDestinationEmit } from '../models/selectDestination';
import { SelectDestinationEmitType } from '../models/selectDestination';
import type { EditTripSelectDestinationStep } from '../models/editTripSteps';
import { EditTripStepType } from '../models/editTripSteps';

interface SelectDestinationStepProps {
  step: EditTripSelectDestinationStep;
}
const props = defineProps<SelectDestinationStepProps>();

interface SelectDestinationStepEmits {
  (eventName: 'select-destination', payload: SelectDestinationEmit): void;
}
const emit = defineEmits<SelectDestinationStepEmits>();

const initialSearchText = computed<string>(() => {
  if (props.step.stepType === EditTripStepType.UpdateDestination) {
    return props.step.currentEditingSegment.destinationName;
  }

  return '';
});

function selectDestination(suggestion: AutoCompleteSuggestion): void {
  switch (props.step.stepType) {
    case EditTripStepType.AddDestinationToOwnStay:
      emit('select-destination', {
        type: SelectDestinationEmitType.AddDestinationToOwnStay,
        suggestion,
        ingredientId: props.step.ownStayDestinationIngredeintId,
      });
      break;

    case EditTripStepType.UpdateDestination:
      emit('select-destination', {
        type: SelectDestinationEmitType.UpdateDestination,
        suggestion,
        ingredientId: props.step.currentEditingSegment.ingredientId,
      });
      break;

    case EditTripStepType.AddDestination:
      emit('select-destination', {
        type: SelectDestinationEmitType.AddDestination,
        suggestion,
      });
      break;

    default:
      exhaustiveGuard(props.step, 'Invalid select destination step');
  }
}
</script>

<template>
  <DestinationSelector
    :search-text="initialSearchText"
    :autocomplete-type="AutoCompleteType.Destination"
    @select-destination="selectDestination"
  />
</template>
